import {AiFillFacebook, AiOutlineInstagram, AiFillLinkedin} from 'react-icons/ai'
// import { AiFillTikTok } from "react-icons/ai";
import {AiOutlineTwitter} from 'react-icons/ai'
import {AiOutlineDribbble} from 'react-icons/ai'
import {AiOutlineLinkedin} from 'react-icons/ai'
// import {AiOutlineFacebook} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import { FaTiktok } from "react-icons/fa";

export const links = [
    {id: 1, link: '/', title: 'Home'},
    {id: 2, link: '/#about', title: 'About'},
    {id: 3, link: '/#portfolio', title: 'Programs'},    
    {id: 4, link: '/#services', title: 'Why Us?'},    
    {id: 5, link: '/#contact', title: 'Contact'},
]


export const socials = [
    {id: 3, link: 'https://www.linkedin.com/company/skill-bridge-intelligence/', icon: <AiFillLinkedin/>},
    {id: 1, link: 'https://www.instagram.com/skillbridge.intelligence/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://www.tiktok.com/@skillbridge.intelligence', icon: <FaTiktok/>},
    
    {id: 4, link: 'https://www.facebook.com/skillbridge.intelligence/', icon: <AiFillFacebook/>}
]